import { Component, OnInit, Input, AfterViewInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { finalize, forkJoin, from, lastValueFrom } from 'rxjs';
import { Utilities } from 'src/app/models/utilities';
import { AppCoreService } from 'src/app/services/app-core.service';
import { GeoService } from 'src/app/services/geo.service';
import { ProductService } from 'src/app/services/products.service';
import { VendorService } from 'src/app/services/vendor.service';
import { ZoneService } from "src/app/services/zone.service";


@Component({
    selector: 'app-zonedetails',
    templateUrl: './zonedetails.component.html',
    styleUrls: ['./zonedetails.component.scss']
})

export class ZoneDetailComponent implements OnInit, AfterViewInit {
    modelZoneForm: FormGroup;
    @Input() public cell: any;
    isFormSubmitted = false;
    vendorList: any = [];
    countryList: [];
    originStateList: [];
    destinationStateList: [];
    originCityList: [];
    destinationCityList: [];
    countryCode: any;
    zoneList: any[];
    productList: any;
    serviceList: any;
    useEnterKey: any;

    constructor(
        private appCoreService: AppCoreService,
        public activeModal: NgbActiveModal,
        private ngxLoaderService: NgxUiLoaderService,
        private _fb: FormBuilder,
        private zoneService: ZoneService,
        private vendorService: VendorService,
        private geoService: GeoService,
        private productService: ProductService,
        private utilities: Utilities,

    ) { }

    async ngOnInit() {
        this.modelZoneForm = this._fb.group({
            ddlProduct: [null],
            ddlVendor: [null],
            ddlZone: [null],
            ddlService: [null],
            ddlOriginState: [],
            ddlOriginCountry: [],
            ddlOriginCity: [],
            ddlDestinationState: [],
            ddlDestinationCountry: [],
            ddlDestinationCity: [],
            txtOriginFromPincode: [null],
            txtOriginToPincode: [null],
            txtDestinationFromPincode: [null],
            txtDestinationToPincode: [null],
            txtFromDate: [null],
            txtToDate: [null],
        });
        // const userData = this.appCoreService.GetUserData();
        // this.useEnterKey = !userData.metaInfo.tabbasedtemplate;
        this.loadDataFromAPI();
    }

    ngAfterViewInit(): void {
        this.useEnterKey ? this.utilities.focusFirstElement(this.modelZoneForm) : null;
    };

    loadDataFromAPI() {
        this.ngxLoaderService.start();
        try {
            forkJoin({
                countries: this.geoService.GetAllCountries(),
                zones: this.zoneService.GetAll(),
                vendors: this.vendorService.GetAll(),
                products: this.productService.GetAll()
            }).pipe(
                finalize(() => {
                    this.bindDetails();
                    this.ngxLoaderService.stop();
                })).subscribe((res) => {
                    if (res) {
                        if (res && res?.countries?.data?.length) {
                            this.countryList = res?.countries?.data;
                        }
                        if (res && res?.zones?.data?.length) {
                            this.zoneList = res?.zones?.data;
                        }
                        if (res && res?.vendors?.data?.length) {
                            this.vendorList = res?.vendors?.data;
                        }
                        if (res && res?.products?.data?.length) {
                            this.productList = res?.products?.data;
                        }
                    }
                });
        } catch (error) {
            this.ngxLoaderService.stop();
        }
    }
    async getAllVendors(): Promise<void> {
        try {
            const observable = this.vendorService.GetAllList();
            const res = await lastValueFrom(observable);
            if (res && res.success) {
                this.vendorList = res.data;
            }

        } catch (e) {
            console.error(e);
        }
    }


    async getAllZones(): Promise<void> {
        try {
            const observable = this.zoneService.GetAll();
            const res = await lastValueFrom(observable);
            if (res && res.success) {
                this.zoneList = res.data;
            }
        } catch (e) {
            console.error(e);
        }
    }

    async getAllVendorServices(eventid?: any, vendorChanged?: any) {
        if (eventid) {
            const vendorcode = this.vendorList.filter((item: any) => item.code == eventid)[0]?.id;
            const vendorid = vendorcode ? vendorcode : eventid
            if (vendorChanged)
                this.modelZoneForm.controls.ddlService.reset();
            try {
                const res = await lastValueFrom(this.vendorService.GetAllListByVendor({ id: vendorid }));
                if (res && res.success) {
                    this.serviceList = res.data;
                }
            } catch (error) {
            }
        }
    }

    async getAllProducts(): Promise<void> {
        try {
            const observable = this.productService.GetAll();
            const res = await lastValueFrom(observable);
            if (res && res.success) {
                this.productList = res.data;
            }

        } catch (e) {
            console.error(e);
        }
    }


    async bindCountries(): Promise<void> {
        try {
            const observable = this.geoService.GetAllCountries();
            const res = await lastValueFrom(observable);
            if (res && res.success) {
                this.countryList = res.data;
            }

        } catch (e) {
            console.error(e);
        }
    }



    async onOriginCountryChange() {
        const countryCode: any = (this.countryList as any).filter((item: any) => item.code == this.modelZoneForm.get('ddlOriginCountry').value)[0]?.isocode;
        if (countryCode) {
            this.modelZoneForm.controls.ddlOriginState.reset();
            this.modelZoneForm.controls.ddlOriginCity.reset();
            this.bindStatesByCountry(countryCode, 'origin');
        }
    }

    async onOriginStateChange() {
        const stateCode: any = (this.originStateList as any).filter((item: any) => item.code == this.modelZoneForm.get('ddlOriginState').value)[0]?.isocode;
        // const countryCode = this.rateDetailsForm.get('ddlOriginState').value;
        if (stateCode) {
            this.modelZoneForm.controls.ddlOriginCity.reset();
            this.bindCitiesByState(stateCode, 'origin');
        }
    }

    async bindCitiesByState(stateCode?: string, type?: any): Promise<void> {
        try {
            if (stateCode) {
                const observable = this.geoService.GetAllCities({ statecode: stateCode });
                const res = await lastValueFrom(observable);
                if (res && res.success) {
                    if (type === 'origin') {
                        this.originCityList = res.data;
                    } else {
                        this.destinationCityList = res.data;
                    }
                }
            }
        } catch (e) {
            console.error(e);
        }
    }

    async onDestinationCountryChange() {
        const countryCode: any = (this.countryList as any).filter((item: any) => item.code == this.modelZoneForm.get('ddlDestinationCountry').value)[0]?.isocode;
        if (countryCode) {
            this.modelZoneForm.controls.ddlDestinationState.reset();
            this.modelZoneForm.controls.ddlDestinationCity.reset();
            this.bindStatesByCountry(countryCode, 'destination');
        }
    }

    async onDestinationStateChange() {
        const stateCode: any = (this.destinationStateList as any).filter((item: any) => item.code == this.modelZoneForm.get('ddlDestinationState').value)[0]?.isocode;
        // const countryCode = this.rateDetailsForm.get('ddlDestinationState').value;
        if (stateCode) {
            this.modelZoneForm.controls.ddlDestinationCity.reset();
            this.bindCitiesByState(stateCode, 'destination');
        }
    }

    async bindStatesByCountry(countryCode?: string, type?: any): Promise<void> {
        try {
            if (countryCode) {
                const observable = this.geoService.GetAllStates({ countrycode: countryCode });
                const res = await lastValueFrom(observable);
                if (res && res.success) {
                    if (type === 'origin') {
                        // console.log('res.data',res.data)
                        this.originStateList = res.data;
                        // console.log('origin',this.originStateList)
                    } else {
                        this.destinationStateList = res.data;
                    }
                }
            }
        } catch (error) {
            console.error(error);
            throw error;
        }
    }

    async bindDetails() {
        try {
            let originstate: any, origincity: any, destinationstate: any, destinationcity: any;
            if (this.cell) {
                // console.log("this modal",res.data );
                const origincountry: any = this.countryList.filter((item: any) => item.code == this.cell?.origincountrycode);
                const destinationcountry: any = this.countryList.filter((item: any) => item.code == this.cell?.destinationcountrycode);
                this.modelZoneForm.get('ddlProduct').setValue(this.cell?.productcode);
                this.modelZoneForm.get('ddlZone').setValue(this.zoneList.find((item: any) => item.code == this.cell?.zonecode)?.id);
                this.modelZoneForm.get('ddlVendor').setValue(this.cell?.vendorcode);
                await this.getAllVendorServices(this.cell?.vendorcode);
                this.modelZoneForm.get('ddlService').setValue(this.cell?.service);

                this.modelZoneForm.get('ddlOriginCountry').setValue(this.cell?.origincountrycode);
                this.modelZoneForm.get('ddlDestinationCountry').setValue(this.cell?.destinationcountrycode);
                await lastValueFrom(from(this.bindStatesByCountry(origincountry?.[0]?.isocode, 'origin')));

                originstate = this.originStateList?.filter((item: any) => item.code == this.cell?.originstatecode);
                await lastValueFrom(from(this.bindCitiesByState(originstate?.[0]?.isocode, 'origin')));

                origincity = this.originCityList?.filter((item: any) => item.code == this.cell?.originstatecode);
                this.modelZoneForm.get('ddlOriginState').setValue(this.cell?.originstatecode);
                this.modelZoneForm.get('ddlOriginCity').setValue(origincity?.isocode);

                await lastValueFrom(from(this.bindStatesByCountry(destinationcountry?.[0]?.isocode)));
                destinationstate = this.destinationStateList?.filter((item: any) => item.code == this.cell?.destinationstatecode);
                await lastValueFrom(from(this.bindCitiesByState(destinationstate?.[0]?.isocode)));

                destinationcity = this.destinationCityList?.filter((item: any) => item.code == this.cell?.destinationcitycode);

                this.modelZoneForm.get('ddlDestinationState').setValue(this.cell?.destinationstatecode);
                this.modelZoneForm.get('ddlDestinationCity').setValue(destinationcity?.isocode);

                this.modelZoneForm.get('txtOriginFromPincode').setValue(this.cell?.originpincodefrom);
                this.modelZoneForm.get('txtOriginToPincode').setValue(this.cell?.originpincodeto);
                this.modelZoneForm.get('txtDestinationFromPincode').setValue(this.cell?.destinationpincodefrom);
                this.modelZoneForm.get('txtDestinationToPincode').setValue(this.cell?.destinationpincodeto);
                this.modelZoneForm.get('txtFromDate').setValue(this.cell?.fromdate);
                this.modelZoneForm.get('txtToDate').setValue(this.cell?.todate);
            }
        } catch (err: any) {
            console.log(err);
        }
    }

    updateZoneDetails(): void {
        let reqObj = {
            id: this.cell,
            product: this.modelZoneForm.get('ddlProduct').value,
            vendor: this.modelZoneForm.get('ddlVendor').value,
            zonecode: this.modelZoneForm.get('ddlZone').value,
            service: this.modelZoneForm.get('ddlService').value,
            originstate: this.modelZoneForm.get('ddlOriginState').value,
            origincountry: this.modelZoneForm.get('ddlOriginCountry').value,
            origincity: this.modelZoneForm.get('ddlOriginCity').value,
            destinationstate: this.modelZoneForm.get('ddlDestinationState').value,
            destinationcountry: this.modelZoneForm.get('ddlDestinationCountry').value,
            destinationcity: this.modelZoneForm.get('ddlDestinationCity').value,
            originformpincode: this.modelZoneForm.get('txtOriginFromPincode').value,
            origintopincode: this.modelZoneForm.get('txtOriginToPincode').value,
            destinationformpincode: this.modelZoneForm.get('txtDestinationFromPincode').value,
            destinationtopincode: this.modelZoneForm.get('txtDestinationToPincode').value,
            fromdate: this.modelZoneForm.get('txtFromDate').value,
            todate: this.modelZoneForm.get('txtToDate').value,
        }
        if (this.modelZoneForm.valid) {
            this.ngxLoaderService.start();
            this.zoneService.UpdateZoneDetail(reqObj).subscribe(res => {
                if (res && res.success) {
                    this.ngxLoaderService.stop();
                    this.appCoreService.showMessage('Detail Updated Successfully.', 'Success', 'success');
                    this.modelZoneForm.reset();
                    this.activeModal.close('Save Click');
                }
            })

            this.ngxLoaderService.stop();
        }
    }

    reset() {
        this.modelZoneForm.reset();
        this.activeModal.close('Cross click');
    }

}